export const MEGTAKARITAS_TIPUS = 'megtakaritas';
export const JARADEK_TIPUS = 'jaradek';

export default class TipusBase {
	isMegtakaritas() {
		return this.tipus == MEGTAKARITAS_TIPUS;
	}
	isJaradek() {
		return this.tipus == JARADEK_TIPUS;
	}
}



// WEBPACK FOOTER //
// ../source/application/kalkulator/lib/tipus-base.js